<template>
    <div class="s-input">
        
        <b-pagination
            :name="name"
            v-model="displayValue"
            :total-rows="totalRows"
            :per-page="perPage"
            :align="align"
            :limit="pageLimit"
            :size="getAllSize.pagination"
            class="pagination"
            style="margin-top: -25px">
            <!--            first-number="true"
            last-number="true"-->

            <!--<template #first-text><span v-if="firstText" class="allText firstText">{{firstText}}</span></template>
            <template v-if="lastText" #last-text><span class="allText lastText">{{lastText}}</span></template>
            <template v-if="prevText" #prev-text><span class="allText prevText">{{prevText}}</span></template>
            <template v-if="nextText" #next-text><span class="allText nextText">{{nextText}}</span></template>

            <template #prev-class><span class="ttt"></span></template>-->

        </b-pagination>

    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default{
    name: "s-input",
    props: ['value', 'totalRows', 'perPage', 'name','pageLimit', 'align', 'firstText', 'lastText', 'prevText', 'nextText'],
    data: function() {
        return {
            
        }
    },
    methods:{

    },
    computed: {
        ...mapGetters(['getAllSize']),
        displayValue: {
            get: function() {
                let sendValue = this.value
                return sendValue
                },
            set: function(modifiedValue) {
                let newValue = modifiedValue
                this.$emit('input', newValue)
            }
        }
    }
}


</script>

<style lang="scss" scoped>
@import "./pagination.scss";
</style>